<template>
  <div class="search__result">
    <ul v-if="categories" class="list--tags">
      <li v-for="category of categories" v-bind:key="category">
        <a @click="handleTagClick(category, $event)" :href="$getSearchPageLink(searchPageLink, category)" class="tag">{{ category }}</a>
      </li>
    </ul>
    <a v-if="data.title" :href="data.url" class="search__result-title h4" v-html="highlightedSearchTerm" target="_blank" rel="noopener noreferrer"></a>
    <p v-if="data.description || data.content" class="search__result-description p--small">
      {{ data.description || data.content }}
    </p>
  </div>
</template>

<script>
import { highlightSearchQuery } from "./utils";

export default {
  name: "search",
  components: {},
  props: {
    data: {},
    searchQuery: {
      type: String,
    },
    searchPageLink: {
      type: String,
    }
  },
  data() {
    return {};
  },
  methods: {
    handleTagClick(category, e) {
      e.preventDefault();

      this.$emit("updateSearchQuery", category);
    },
  },
  computed: {
    categories() {
      if (!this.data.categories) return;

      return this.data.categories.split(",");
    },
    highlightedSearchTerm() {
      if (!this.searchQuery) return;

      return highlightSearchQuery(this.data.title, this.searchQuery);
    },
  },
};
</script>
